/* eslint-disable max-len */
import { Plugins } from '@leverege/plugin';
import TypePlugins from "./type/PluginSetup.js";
import SharedPlugins from "./shared/PluginSetup.js";
Plugins.on('AttributeConditionComparator', evt => {
  if (evt.type === 'pluginAdded') {
    Plugins.add('Model', {
      type: evt.plugin.type,
      model: evt.plugin
    });
  }
  if (evt.type === 'pluginRemoved') {
    Plugins.remove('Model', {
      type: evt.plugin.type,
      model: evt.plugin
    });
  }
});
Plugins.on('AttributeConditionComparatorEditor', evt => {
  if (evt.type === 'pluginAdded') {
    Plugins.add('ModelEditor', evt.plugin);
  }
  if (evt.type === 'pluginRemoved') {
    Plugins.remove('ModelEditor', evt.plugin);
  }
});
export default {
  install(opts) {
    TypePlugins.install(opts);
    SharedPlugins.install(opts);
  }
};